import React from 'react';
const ChatBotConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/adminchatbot',
			component: React.lazy(() => import('./autoReplyTable'))
		}
	]
};

export default ChatBotConfig;
